export default __webpack_public_path__ + "static/companies-serviced-bg-image-eebcf065ffd15f93013f047045431554.jpg";